import React from 'react'
import { Tag } from 'antd'
import { ActiveRequest, Connection } from './interfaces/interfaces'

const formatDuration = (ms: number): string => {
  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  if (hours > 0) return `${hours}ч ${minutes % 60}м`
  if (minutes > 0) return `${minutes}м ${seconds % 60}с`
  return `${seconds}с`
}

export const activeRequestsColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    render: (id: string) => <code style={{ fontSize: 11 }}>{id.substring(0, 20)}...</code>
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId'
  },
  {
    title: 'Email',
    dataIndex: 'to',
    key: 'to'
  },
  {
    title: 'Время выполнения',
    dataIndex: 'runningTime',
    key: 'runningTime',
    render: (time: number) => formatDuration(time)
  },
  {
    title: 'Статус',
    key: 'status',
    render: (_: any, record: ActiveRequest) => {
      const isStuck = record.runningTime > 120000
      return (
        <Tag color={isStuck ? 'red' : record.runningTime > 60000 ? 'orange' : 'green'}>
          {isStuck ? 'Зависло' : 'В процессе'}
        </Tag>
      )
    }
  }
]

export const connectionsColumns = [
  {
    title: 'Office ID',
    dataIndex: 'officeId',
    key: 'officeId'
  },
  {
    title: 'Тип',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: 'Последнее использование',
    dataIndex: 'lastUsed',
    key: 'lastUsed',
    render: (lastUsed: number) => formatDuration(Date.now() - lastUsed) + ' назад'
  },
  {
    title: 'Статус',
    dataIndex: 'isStale',
    key: 'isStale',
    render: (isStale: boolean) => (
      <Tag color={isStale ? 'orange' : 'green'}>{isStale ? 'Устарело' : 'Активно'}</Tag>
    )
  }
]

